import axios from 'axios';

const countryApi = axios.create({
	// baseURL: 'https://test-api.nexon.io',
	baseURL: '/api/country/v1',
	withCredentials: true,
	timeout: 10000,
});

export default countryApi;
